import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/ticket',
      component: () => import('../views/ticket.vue')
    }, {
      path: '/mcgame',
      component: () => import('../views/mcgame.vue')
    }
  ]
})
 
